import React from "react";
import Certificate from "./sertificate";
import School from "./school";
import EducationStatus from "./education-status";


export default function Education({ employeeId }) {

    if (!employeeId)
        return undefined;

    return (
        <React.Fragment>

            <EducationStatus employeeId={employeeId} />

            <br /><br />
            <div className="dx-form-group-caption buttom-orange-line">Okul Bilgileri</div>
            <School employeeId={employeeId} />
            <br /><br />
            <div className="dx-form-group-caption buttom-orange-line">Sertifika - Eğitim  Bilgileri</div>
            <Certificate employeeId={employeeId} />
        </React.Fragment>
    )
}